import { header } from "../../../context/constant";
import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { deleteMenuEp as endpoint } from "../apiEndpoints";

const DeleteMenuApi = async (id:string) => {
  const url = endpoint(id)
  const options: FetchOptions= {
    method: "DELETE",
    headers:header,
    
  }
  return fetchInterceptor(url, options)
};
export default DeleteMenuApi;
